export default __webpack_public_path__ + "static/media/appGIF.f7d1b648.gif";